import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

interface FieldsChanges {
  sub: Subscription;
  observable: Observable<any>;
}

@Injectable()
export class FormFieldsChangesSubService implements OnDestroy {
  fieldsChangesMap = new Map<string, FieldsChanges>();

  ngOnDestroy(): void {
    this.fieldsChangesMap.forEach(sub => sub.sub.unsubscribe());
    this.fieldsChangesMap.clear();
  }

  subscribe(key: string, observable: Observable<any>): void {
    if (this.fieldsChangesMap.has(key)) {
      this.fieldsChangesMap.get(key).sub.unsubscribe();
    }

    this.fieldsChangesMap.set(key, {
      observable,
      sub: observable.subscribe(),
    });
  }

  resubscribe(key: string): void {
    if (!this.fieldsChangesMap.has(key)) {
      return;
    }

    this.subscribe(key, this.fieldsChangesMap.get(key).observable);
  }

  pauseSubscription(key: string): void {
    if (!this.fieldsChangesMap.has(key)) {
      return;
    }

    this.fieldsChangesMap.get(key).sub.unsubscribe();
  }

  pauseAllSubscriptions(): void {
    Array.from(this.fieldsChangesMap.keys()).map(key => this.pauseSubscription(key));
  }

  resubscribeAll(): void {
    Array.from(this.fieldsChangesMap.keys()).map(key => this.resubscribe(key));
  }
}
